import { QUOTE_CATEGORY } from '../keys'
const initialState = { categorydata: [] }
export default function reducer(state = initialState, action) {
    switch (action.type) {
       
        case QUOTE_CATEGORY: {
            
            return { ...state, categorydata: action.payload }
        }
        default:
           
            return { ...state }
    }

}